import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRound, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePermissions } from '@/context/PermissionsContext';

// Aviso cuando el usuario aún no ha escrito su nombre (el sistema muestra el prefijo del correo en "Registró", bitácora, etc.)
export const ProfileNameNotice = ({ pathname }) => {
  const { me } = usePermissions();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem('profile-name-notice') === '1');
  if (!me?.name_pending || hidden || pathname.startsWith('/app/settings')) return null;
  const shown = (me.full_name || '').trim() || (me.email || '').split('@')[0];
  const dismiss = () => { sessionStorage.setItem('profile-name-notice', '1'); setHidden(true); };
  return (
    <div className="mb-6 flex flex-col gap-3 rounded-xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-900 sm:flex-row sm:items-center" data-testid="profile-name-notice">
      <UserRound className="hidden h-5 w-5 shrink-0 sm:block text-sky-700" />
      <p className="flex-1">
        Tu nombre aparece como <span className="font-mono font-semibold">{shown}</span> en los registros que haces (Verificar, bitácora, solicitudes).
        Escribe tu nombre completo en <span className="font-semibold">Mi perfil</span> para que el equipo te identifique.
      </p>
      <div className="flex items-center gap-2">
        <Button size="sm" className="h-8 bg-sky-700 hover:bg-sky-800" onClick={() => navigate('/app/settings')} data-testid="profile-name-notice-go">Completar nombre</Button>
        <Button size="sm" variant="ghost" className="h-8 w-8 p-0 text-sky-700 hover:bg-sky-100" onClick={dismiss} aria-label="Cerrar" data-testid="profile-name-notice-dismiss"><X className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
